import { useEffect } from 'react';
import { trackEvent } from '../lib/analytics';
import { OdsAlert } from './orderly/OdsAlert';
import { OdsButton } from './orderly/OdsButton';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  useEffect(() => {
    trackEvent('component_viewed', {
      component: 'ErrorMessage',
      status: message,
    });
  }, [message]);

  return (
    <OdsAlert type="negative" className="items-center">
      <div className="flex items-center gap-3">
        <span className="min-w-0 flex-1 break-words">{message}</span>
        {onRetry && (
          <OdsButton variant="secondary" size="small" className="shrink-0" onClick={onRetry}>
            Retry
          </OdsButton>
        )}
      </div>
    </OdsAlert>
  );
}
